/**
 * @generated SignedSource<<bc0c7fbaa1327449fcd25d369d86454d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LocationText_location$data = {
  readonly name: string;
  readonly isOutdoor: boolean;
  readonly facility: {
    readonly name: string;
  } | null;
  readonly " $fragmentType": "LocationText_location";
};
export type LocationText_location$key = {
  readonly " $data"?: LocationText_location$data;
  readonly " $fragmentSpreads": FragmentRefs<"LocationText_location">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LocationText_location",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOutdoor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Facility",
      "kind": "LinkedField",
      "name": "facility",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Location",
  "abstractKey": null
};
})();

(node as any).hash = "d1522b9908f74f60678f209842826bb2";

export default node;
